import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/app/AppShell";
import { RequireAuth, RequireSignedIn } from "./components/app/RequireAuth";
import { SessionProvider } from "./services/SessionContext";
import { LandingPage } from "./pages/LandingPage";
import { SignInPage } from "./pages/auth/SignInPage";
import { SignUpPage } from "./pages/auth/SignUpPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { VerifyEmailPage } from "./pages/auth/VerifyEmailPage";
import { CompanySetupPage } from "./pages/app/CompanySetupPage";
import { DashboardPage } from "./pages/app/DashboardPage";
import { UploadPage } from "./pages/app/UploadPage";
import { UploadDetailPage } from "./pages/app/UploadDetailPage";
import { EventDetailPage } from "./pages/app/EventDetailPage";
import { EditUploadPage } from "./pages/app/EditUploadPage";
import { ShareUploadPage } from "./pages/app/ShareUploadPage";
import { TeamPage } from "./pages/app/TeamPage";
import { RepositoryPage } from "./pages/app/RepositoryPage";
import { SharedLinksPage } from "./pages/app/SharedLinksPage";
import { PublicSharePage } from "./pages/share/PublicSharePage";

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth/sign-in" element={<SignInPage />} />
          <Route path="/auth/sign-up" element={<SignUpPage />} />
          <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route element={<RequireSignedIn />}>
            <Route path="/auth/verify-email" element={<VerifyEmailPage />} />
            <Route path="/app/setup" element={<CompanySetupPage />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route path="/app" element={<AppShell />}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="repository" element={<RepositoryPage />} />
              <Route path="uploads/new" element={<UploadPage />} />
              <Route path="uploads/:uploadId" element={<UploadDetailPage />} />
              <Route path="uploads/:uploadId/events/:eventId" element={<EventDetailPage />} />
              <Route path="uploads/:uploadId/edit" element={<EditUploadPage />} />
              <Route path="uploads/:uploadId/share" element={<ShareUploadPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="shared" element={<SharedLinksPage />} />
            </Route>
          </Route>
          <Route path="/s/:shareId" element={<PublicSharePage expectedType="PUBLIC" />} />
          <Route path="/c/:shareId" element={<PublicSharePage expectedType="CLIENT_SAFE" />} />
          <Route path="/support/:shareId" element={<PublicSharePage expectedType="SUPPORT" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}
